import React, { memo } from 'react';
import { Trans } from 'react-i18next';

import Header from 'components/header';
import Image from 'components/image';
import { closeWebView } from 'utils';
import './styles.scss';

const Error = () => {
  return (
    <>
      <Header hideBackBtn onClick={closeWebView} />
      <div className="error-container flex flex-col w-100 items-center justify-center">
        <Image className="mb1" src={require('assets/images/thinking-face.png')} />
        <div className="error-message"><Trans i18nKey="errorMessage" /></div>
      </div>
    </>
  );
};

export default memo(Error);
